import { observable, action } from 'mobx'
import ManagementViewStore from '../store/ManagementViewStore'
import GlobalControlStore from './GlobalControlStore'
import GroupInfoStore from './GroupInfoStore'
import {
  getWeChatBindInfo,
  getAreaFetchHandler,
  getCleanerInfoFetchHandler,
} from '../utils/fetchData'

/*
  searchList 搜索列表
  adminListHeight 区域划分界面的admin的div高度
  buildAdminHeight 区域划分界面的创建admin的高度
  choseEditCleanerNum 编辑cleaner的时候选中的是第几个nav
  choseEditAdminNum 编辑admin的时候选中的是第几个nav
  cleanerNum 当前选中的admin下面有多少个cleaner
  weChatBindArr 当前选中的admin的绑定的微信集合
  editUserPhone 当前编辑的人员的绑定电话号
  editUserPhoneState 当前编辑的人员的电话是否开通消息提醒
  searchContent 搜索內容
  cleanerDomMap 将cleaner的dom对象存起来
*/

class Store {
  @observable adminListHeight = 500
  @observable buildAdminHeight = 300
  @observable buildCleanerHeight = 300
  @observable editAdminHeight = 300
  @observable editCleanerHeight = 300
  @observable choseEditAdminNum = 0
  @observable choseEditCleanerNum = 0
  @observable cleanerNum = 0
  @observable weChatBindArr = []
  @observable editUserPhone = ''
  @observable editUserPhoneState = false
  @observable editUserEmail = ''
  @observable editUserEmailState = false
  @observable searchList = []
  @observable searchContent = ''
  @observable cleanerDomMap = new Map()

  @action.bound
  async getEditAdminInfo(id) {
    let [res, bindRes] = await Promise.all([
      getAreaFetchHandler(id),
      getWeChatBindInfo(id),
    ])
    if (res.ok) {
      let resBody = await res.json()
      this.getAreaSuccess(resBody)
    }
    if (bindRes.ok) {
      let resBody = await bindRes.json()
      this.getWeChatBindInfoSuccess(resBody)
    }
  }
  @action getAreaSuccess(res) {
    let index = 0
    let percentage
    ManagementViewStore.editAreaName = res.meta.admin.district
    ManagementViewStore.editAreaUser = res.username
    ManagementViewStore.editAreaAdmin = res.name
    ManagementViewStore.editAreaPhone = res.phone
    ManagementViewStore.editCleanerNum = res.meta.admin.cleaners_number
    ManagementViewStore.editCarNum = res.meta.admin.cars_number
    if (res.meta.admin.district) index++
    if (res.name) index++
    if (res.meta.admin.cleaners_number != undefined) index++
    if (res.meta.admin.cars_number != undefined) index++
    percentage = (index / 4).toFixed(2) * 100
    ManagementViewStore.editAreaIntegrity = percentage
    //此处 unset 仅作为判断的条件，不作为语言展示
    this.editUserPhone = res.phone || 'unset'
    this.editUserPhoneState = res.phoneState
    this.editUserEmail = res.email || 'unset'
    this.editUserEmailState = res.emailState
    GlobalControlStore.TopTips = res.remindStickySwitch
    GlobalControlStore.MusicTips = res.remindSoundSwitch
    GlobalControlStore.showLoading = false
  }
  @action getWeChatBindInfoSuccess(res) {
    RegionalDivisionStore.weChatBindArr = res.content
  }

  //获取编辑的cleaner的信息
  @action.bound
  async getEditCleanerInfo(id) {
    let [res, bindRes] = await Promise.all([
      getCleanerInfoFetchHandler(id),
      getWeChatBindInfo(id),
    ])
    if (res.ok) {
      let resBody = await res.json()
      this.getCleanerInfoSuccess(resBody)
    } else {
      let resBody = await res.json()
      this.getCleanerInfoFail(resBody)
    }
    if (bindRes.ok) {
      let resBody = await bindRes.json()
      this.getWeChatBindInfoSuccess(resBody)
    }
  }
  @action getCleanerInfoSuccess(res) {
    let index = 0
    let checkedAdmin = GroupInfoStore.adminInfoMap.get(
      ManagementViewStore.checkedAdminId
    )
    ManagementViewStore.editCleanerAreaName = res.meta.cleaner.district || ''
    ManagementViewStore.editCleanerUser = res.username
    ManagementViewStore.editCleanerBoss = res.name || ''
    ManagementViewStore.editCleanerBelong = checkedAdmin.meta.district
    ManagementViewStore.editCleanerPhone = res.phone || ''
    ManagementViewStore.editCleanerCar = res.meta.cleaner.car_capacity
    if (res.meta.cleaner.district) index++
    if (res.name) index++
    if (res.meta.cleaner.car_capacity != undefined) index++
    let percentage = (index / 3).toFixed(2) * 100
    ManagementViewStore.editCleanerIntegrity = percentage
    //此处 unset 仅作为判断的条件，不作为语言展示
    this.editUserPhone = res.phone || 'unset'
    this.editUserPhoneState = res.phoneState
    this.editUserEmail = res.email || 'unset'
    this.editUserEmailState = res.emailState
    GlobalControlStore.showLoading = false
  }
  @action getCleanerInfoFail(err) {}
}

const RegionalDivisionStore = new Store()

export default RegionalDivisionStore



// WEBPACK FOOTER //
// ./src/store/RegionalDivisionStore.js